import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ } from "../data/cabanas";

export const Faq = () => (
  <section id="faq" className="py-24 bg-[#f5f0eb]" data-testid="faq-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <p className="text-[#b85d39] text-xs uppercase tracking-[0.3em] font-bold mb-3">
        Dúvidas frequentes
      </p>
      <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#1b4332] mb-10">
        Perguntas Frequentes
      </h2>
      <Accordion type="single" collapsible className="flex flex-col gap-3">
        {FAQ.map((f, i) => (
          <AccordionItem
            key={f.pergunta}
            value={`item-${i}`}
            data-testid={`faq-accordion-item-${i}`}
            className="bg-white rounded-xl border border-[#e2d9cd] px-6 shadow-sm"
          >
            <AccordionTrigger className="text-left text-base font-bold text-[#1b4332] hover:no-underline py-5">
              {f.pergunta}
            </AccordionTrigger>
            <AccordionContent className="text-sm text-[#526559] leading-relaxed pb-5">
              {f.resposta}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  </section>
);
